import React from 'react';
import { cn } from '@/utils/common-helpers';
import Image from 'next/image';

export function FeaturesSectionHoverEffectsBaServiceBaaas() {
    const features = [
        {
            title: 'Requirement Engineering',
            description:
                'The requirement engineering involves concept understanding where feasibility analysis is conducted to assess project requirements with proper market and competitor analysis. User Stories are prepared to get a clear understanding of the requirements',
            icon: '/img/technology/ic-requirement.svg',
        },
        {
            title: 'Requirement re-engineering',
            description:
                'Our BA Experts analyze the existing product/software and perform reverse engineering thus providing iterative and effective updates for further enhancements.',
            icon: '/img/technology/ic-development-cycle.svg',
        },
        {
            title: 'System Architecture Optimization',
           description:
                'Finding external systems, technology, frameworks, and libraries to enhance the product features and functionalities and optimize the overall effort. Our BA analyst team can convert your legacy system into a new system with overall enhanced performance.',
            icon: '/img/technology/ic-system-architecture-optimization.svg',
        },
        {
            title: 'Wireframing',
            description:
                "The main purpose of the low or high-fidelity wireframes at the early development stage is to provide a visual understanding of the product screens to the stakeholders. This would help them understand, and how a page would cater to users' needs while fulfilling business objectives.",
            icon: '/img/technology/ic-wireframe.svg',
        },
        {
            title: 'UI/UX Designing',
            description:
                'Our team would design screens with detailed graphic elements and prototype complex ideas along with preparing extensive brand guidelines including Icons, Logos, Typographies, and font selection so that our clients can maintain brand consistency and develop their impact across platforms globally.',
            icon: '/img/technology/ic-ui-ux.svg',
        },
        {
            title: 'Technical Documentation',
            description:
                'The technical diagrams help clients visualize the way the system will be designed. It also involves a typical SRS document which describes all the software requirements in detail including domain requirements, technologies, and frameworks with its detailed versioning.',
            icon: '/img/technology/ic-technical-document.svg',
        },
        {
            title: 'Time & Cost Estimation',
            description:
                'Our team would design screens with detailed graphic elements and prototype complex ideas along with preparing extensive brand guidelines including Icons, Logos, Typographies, and font selection so that our clients can maintain brand consistency and develop their impact across platforms globally.',
            icon: '/img/technology/ic-time-estimation.svg',
        },
    ];
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3  relative z-10 max-w-7xl mx-auto">
            {features.map((feature, index) => (
                <Feature key={feature.title} {...feature} index={index} total={features.length} />
            ))}
        </div>
    );
}

const Feature = ({
    title,
    description,
    icon,
    index,
    total,
}: {
    title: string;
    description: React.ReactNode;
    icon: string;
    index: number;
    total: number;
}) => {
    return (
        <div
            className={cn(
                'flex flex-col py-[30px] relative group/feature dark:border-neutral-800',
                index % 3 === 0 && 'lg:border-l dark:border-neutral-800',
                (index + 1) % 3 !== 0 && 'lg:border-r dark:border-neutral-800',
                index >= 3 && 'lg:border-t dark:border-neutral-800 ',
                index === 4 && 'lg:border-b dark:border-neutral-800 mb-[-1px]',
                index === 5 && 'lg:border-b dark:border-neutral-800 mb-[-1px]',
                index === 5 && total % 2 === 0 && 'mb-[-1.2px]',
            )}
        >
            {index < 3 && (
                <div className="opacity-0 group-hover/feature:opacity-100 transition duration-200 absolute inset-0 h-full w-full bg-gradient-to-t from-neutral-100 dark:from-neutral-800 to-transparent pointer-events-none" />
            )}
            {index >= 3 && (
                <div className="opacity-0 group-hover/feature:opacity-100 transition duration-200 absolute inset-0 h-full w-full bg-gradient-to-b from-neutral-100 dark:from-neutral-800 to-transparent pointer-events-none" />
            )}
            <div className="mb-[10px] relative z-10 px-10 text-neutral-600 dark:text-neutral-400">
                <Image src={icon} width={36} height={36} alt={title} title={title} className="" />
            </div>
            <div className="text-2xl font-bold mb-[10px] relative z-10 px-[30px]">
                <div className="absolute left-0 inset-y-0 h-6 group-hover/feature:h-8 w-1 rounded-tr-full rounded-br-full bg-neutral-300 dark:bg-neutral-700 group-hover/feature:bg-primary transition-all duration-200 origin-center" />
                <span className="group-hover/feature:translate-x-2 group-hover/feature:text-primary transition duration-200 inline-block text-neutral-800 dark:text-neutral-100">
                    {title}
                </span>
            </div>
            <p className="text-[#4C5773] mb-0 text-base text-neutral-600 dark:text-neutral-300 relative z-10 px-[30px]">
                {description}
            </p>
        </div>
    );
};
